export const getCorporateToken = () => {
  const token = localStorage.getItem("corporateToken");
  // Ensure token is not empty or invalid
  return token && token.trim() ? token : null;
};

export const getCorporateMember = () => {
  try {
    const raw = localStorage.getItem("corporateMember");
    if (!raw) return null;

    const member = JSON.parse(raw);
    // Validate member object has required fields
    if (member && (member._id || member.id) && member.email) {
      return member;
    }
    return null;
  } catch (e) {
    console.error("Error parsing corporateMember:", e);
    return null;
  }
};

export const clearCorporateSession = () => {
  localStorage.removeItem("corporateToken");
  localStorage.removeItem("corporateMember");
  localStorage.removeItem("corporateBookingMode");
};

// Validate if corporate session is active and valid
export const isValidCorporateSession = () => {
  const token = getCorporateToken();
  const member = getCorporateMember();
  return !!(token && member);
};
